import translator from '@Components/Utilities/Translator';
import TranslationText from '@Components/Utilities/TranslationText';
import { useState, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { bidderStatus } from '@Components/Utilities/SandhillsConstants';
import BidderStatusMessage from '@Components/Info/BidderStatusMessage';
import { ThemedLinkButton } from '@Components/MuiWrappers/Button';
import ListingBiddingBox from '@Components/Listings/ListingBiddingBox';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { ThemeProvider } from '@emotion/react';
import { ThemedBox } from '@Components/MuiWrappers/ThemedBox';
import atoms from '@Components/Utilities/SandhillsAtoms';

const DetailBiddingBox = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const currentUser = useRecoilValue(atoms.currentUser);
    const routes = useRecoilValue(atoms.routes);
    const linkTarget = !currentSite.IsFramelessSite ? "_blank" : "";
    const theme = useRecoilValue(atoms.muiThemes);
    const returnFocusRef = useRef(null);
    //if bidder status is discard or revoked, show the full status message immediately
    //otherwise we show the "more info" toggle
    const bidderIsDiscardedOrRevoked = [bidderStatus.REVOKED, bidderStatus.DISCARD].includes(props.BidderStatusMessageModel?.BidderStatus);    
    //Revoked/Discarded or Newly Registered user(Could be from THO/MAT) with no Bidding Status.
    const [showBiddingStatusMessage, setShowBiddingStatusMessage] = useState(bidderIsDiscardedOrRevoked);
    
    const getBiddingStatusDependentMarkup = () => {
        if (props.BidderStatusMessageModel.IsGuest || !props.BidderStatusMessageModel.BidderStatus || props.BidderStatusMessageModel.BidderStatus == bidderStatus.PENDING) {
            if (props.BidderStatusMessageModel.IsGuest) {
                return (
                    // Show bidding box for guest user, with redirect to log in
                    <ListingBiddingBox
                        AuctionBiddingData={props.AuctionBiddingData}
                        hideCurrentBid
                        BiddingAgreementData={props.BiddingAgreement}
                        resetAuctionData={props.resetAuctionData}
                        setQuickBidError={props.setQuickBidError}
                        setWaitingForQuickBidAttemptResponseFlag={props.setWaitingForQuickBidAttemptResponseFlag}
                        dealerName={props.AuctioneerName || props.ContactInfo?.CompanyName}
                        EventPhoneNumber={props.EventPhoneNumber}
                        textboxStyles={{ width: '50%' }}
                        notificationSettings={props.notificationSettings}
                        WatchlistUrl={props.WatchlistUrl}
                        IsDetailPage={true}
                        showBoxOnly
                        listingCountry={props.listingCountry}
                        EventStartDateTime={props.EventStartDateTime}
                        BidPopUpURL={props.BidPopUpURL}
                        SellerCRMID={props.ContactInfo?.ParentAccountCRMID}
                        AuctionID={props.AuctionID}
                        AuctionName={props.AuctionName}
                        IsAT={props.IsAT}
                        IsEF={props.IsEF}
                        isQuickBiddingEnabled={props.IsQuickBidEnabled ?? false}
                        displayAutoBidIncrementModal={props.displayAutoBidIncrementModal}
                        AutoBidIncrementData={props?.AutoBidIncrementData}
                    />
                );
            } else {
                return (
                    <>                        
                        <p style={{ fontSize: '14px', fontWeight: '700' }} >{currentUser?.UserFirstName}, {translator.translate('sandhills.incompleteregistration')}</p>
                        <Button className="template-branded-button yellow-btn" variant="contained" href={routes.BidderRegistration}>
                            {translator.translate('sandhills.continueregistration')}
                        </Button>
                    </>
                )
            }
        } else if (![bidderStatus.REVOKED, bidderStatus.DISCARD].includes(props.BidderStatusMessageModel.BidderStatus)) {
            if (!props.AuctionBiddingData.BiddingAllowed && !props.IsAT) {
                if ((props.BiddingAgreement && !props.BiddingAgreement.BidAgreement?.UserIsApproved)) {
                    return (                
                        <>
                            <p className='font14'>{translator.translate('sandhills.prebiddingnotavailable')}</p>
                            <ListingBiddingBox
                                AuctionBiddingData={props.AuctionBiddingData}
                                hideCurrentBid
                                BiddingAgreementData={props.BiddingAgreement}
                                resetAuctionData={props.resetAuctionData}
                                setQuickBidError={props.setQuickBidError}
                                setWaitingForQuickBidAttemptResponseFlag={props.setWaitingForQuickBidAttemptResponseFlag}
                                dealerName={props.AuctioneerName || props.ContactInfo?.CompanyName}
                                EventPhoneNumber={props.EventPhoneNumber}
                                textboxStyles={{ width: '50%' }}
                                notificationSettings={props.notificationSettings}
                                WatchlistUrl={props.WatchlistUrl}
                                IsDetailPage={true}
                                listingCountry={props.listingCountry}
                                EventStartDateTime={props.EventStartDateTime}
                                BidPopUpURL={props.BidPopUpURL}
                                SellerCRMID={props.ContactInfo?.ParentAccountCRMID}
                                AuctionID={props.AuctionID}
                                AuctionName={props.AuctionName}
                                IsAT={props.IsAT}
                                IsEF={props.IsEF}
                                isQuickBiddingEnabled={props.IsQuickBidEnabled ?? false}
                                displayAutoBidIncrementModal={props.displayAutoBidIncrementModal}
                                AutoBidIncrementData={props?.AutoBidIncrementData}
                            />        
                        </>
                    );
                } else {
                    return (
                        <p className='font14'>{translator.translate('sandhills.prebiddingnotavailable')}</p>
                    );
                }
            }
            else if (props.AuctionBiddingData.IsAllBiddingPaused) {
                return (<p className='font14'>{translator.translate('sandhills.tradepubwebsite.mvc.temporarilypausingmessage')}</p>);
            }
            else if (props.AuctionBiddingData.IsListingPaused) {
                return (<p className='font14'>{translator.translate('sandhills.tradepubwebsite.mvc.biddingpausedmessage')}</p>);
            }
            else {
                //user is approved to bid
                return (
                    <ListingBiddingBox
                        AuctionBiddingData={props.AuctionBiddingData}
                        hideCurrentBid
                        BiddingAgreementData={props.BiddingAgreement}
                        resetAuctionData={props.resetAuctionData}
                        setQuickBidError={props.setQuickBidError}
                        setWaitingForQuickBidAttemptResponseFlag={props.setWaitingForQuickBidAttemptResponseFlag}
                        dealerName={props.AuctioneerName || props.ContactInfo?.CompanyName}
                        EventPhoneNumber={props.EventPhoneNumber}
                        textboxStyles={{ width: '50%' }}
                        notificationSettings={props.notificationSettings}
                        WatchlistUrl={props.WatchlistUrl}
                        IsDetailPage={true}
                        listingCountry={props.listingCountry}
                        EventStartDateTime={props.EventStartDateTime}
                        BidPopUpURL={props.BidPopUpURL}
                        SellerCRMID={props.ContactInfo?.ParentAccountCRMID}
                        AuctionID={props.AuctionID}
                        AuctionName={props.AuctionName}
                        IsAT={props.IsAT}
                        IsEF={props.IsEF}
                        isQuickBiddingEnabled={props.IsQuickBidEnabled ?? false}
                        displayAutoBidIncrementModal={props.displayAutoBidIncrementModal}
                        AutoBidIncrementData={props?.AutoBidIncrementData}
                    />
                );
            }
        }

        return null;
    };

    const onBidderStatusModalToggle = () => {
        if (returnFocusRef.current) {
            returnFocusRef.current.focus();
        }
        setShowBiddingStatusMessage(showBiddingStatusMessage => !showBiddingStatusMessage);
    }

    const getHeadingText = () => {
        return props.IsLiveEvent ? translator.translate('sandhills.tradepubwebsite.mvc.bidnow') : translator.translate('sandhills.tradepubwebsite.mvc.bidding');
    }

    return (
        <>
            <ThemeProvider theme={(!theme.isHostedSite && theme.mainMode == "dark") ? theme.darkTheme : theme.lightTheme}>
                <ThemedBox>
                    <div className='dealer-contact'>
                        <div className='bidding-box-details'>
                            <div className='bidding-box-details__header'>
                                <h3 className='bidding-box-details__heading'>{getHeadingText()}</h3>                                                                    
                                {!bidderIsDiscardedOrRevoked &&
                                    <>
                                        <ThemedLinkButton variant='text' size='small' ref={returnFocusRef} className='bidding-box-details__more-info' onClick={() => setShowBiddingStatusMessage(!showBiddingStatusMessage)} sx={{ fontWeight: 'normal', color: 'inherit' }}>
                                            {translator.translate('sandhills.tradepubwebsite.mvc.moreinfo')}
                                            <Icon baseClassName='fas' className='fa-info-circle bidding-box-details__more-info-icon' />
                                            <div className='bidder-tooltip'>
                                                <strong>{translator.translate('sandhills.havequestions')}</strong>
                                                <br />
                                                <p>{translator.translate('sandhills.tradepubwebsite.mvc.numbersandhoursstatustext', [props.BidderStatusMessageModel.TollFreeNumber, props.BidderStatusMessageModel.PhoneNumber])}</p>
                                                <p>{translator.translate('sandhills.tradepubwebsite.mvc.officehours')}</p>
                                            </div>                                            
                                        </ThemedLinkButton>
                                    </>
                                }
                            </div>
                            <div className='bidding-box-details__body'>
                                {props.IsLiveEvent &&
                                    <p className='bidding-box-details__auction-in-progress'>{translator.translate('sandhills.tradepubwebsite.mvc.thisauctionisinprogress')}</p>
                                }
                                    <div className='bidding-box-details__buttons'>
                                        {props.AuctionEventLink &&
                                            <ThemedLinkButton variant='text' size='small' href={props.AuctionEventLink.Url} target={linkTarget} className={'bidding-box-details__link'} sx={{ justifyContent: 'flex-start' }}>
                                                {props.AuctionEventLink.DisplayText}
                                                <Icon baseClassName='fas' className='fa-external-link-alt' />
                                            </ThemedLinkButton>
                                        }
                                </div>
                            </div>
                            <div className='bidding-box-details__status'>
                                {getBiddingStatusDependentMarkup()}
                            </div>
                            {showBiddingStatusMessage &&
                                <BidderStatusMessage {...props.BidderStatusMessageModel} showFullMessage={bidderIsDiscardedOrRevoked}/>
                            }
                        </div>
                    </div>
                </ThemedBox>
            </ThemeProvider>
            {props?.AuctionBoardURL &&
                < div className='enter-auction-btn'>
                    <a className='ts-button red-btn' target='_blank' href={props.AuctionBoardURL.Url} aria-label={props.AuctionBoardURL.DisplayText + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{props.AuctionBoardURL.DisplayText}</a>
                </div>}
        </>
    );
};

export default DetailBiddingBox;